import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconStopCircleSvg } from "./IconStopCircleSvg.mjs";
const IconStopCircle = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconStopCircleSvg, ...iconProps });
};
export {
  IconStopCircle
};
